import Reveal from "@/components/Reveal";

const DEPARTMENTS = [
  {
    tag: "Medical Affairs",
    desc: "Scientific narratives grounded in patient experience.",
  },
  {
    tag: "HEOR",
    desc: "Patient-centered evidence supporting value and outcomes discussions.",
  },
  {
    tag: "Market Access",
    desc: "Payer-relevant patient burden and unmet-need evidence.",
  },
  {
    tag: "Regulatory Affairs",
    desc: "Patient experience insights that support evidence planning and regulatory strategy.",
  },
  {
    tag: "Brand & Commercial",
    desc: "Evidence-informed messaging aligned with real-world patient needs.",
  },
  {
    tag: "Patient Engagement",
    desc: "Actionable insights into community priorities, concerns, and support gaps.",
  },
];

export default function DepartmentsSection() {
  return (
    <section className="bg-ink-1 relative" data-testid="departments-section">
      <div className="container-edge py-24 lg:py-32">
        <Reveal>
          <div className="eyebrow">One patient voice. Multiple teams.</div>
          <h2 className="font-serif font-normal text-3xl md:text-5xl lg:text-[3.5rem] tracking-tight mt-4 text-parchment-bright max-w-4xl leading-[1.05]">
            Patient voice remains constant.
            <span className="block italic">The output changes by function.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/[0.08] border border-white/[0.08]">
          {DEPARTMENTS.map((d, i) => (
            <Reveal
              key={d.tag}
              delay={i * 70}
              className="bg-ink-2 p-8 card-dark-hover"
              data-testid={`department-${d.tag.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-rust mb-4">{d.tag}</div>
              <p className="font-serif text-[1.35rem] text-parchment-bright leading-snug">{d.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
